import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Menu, Search, LogOut } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

export function PlatformTopbar({ onOpenMobileMenu }) {
  const auth = useAuth();
  const user = auth?.user;
  const doLogout = auth?.logout || auth?.signOut;
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [termo, setTermo] = useState("");

  const buscar = (e) => {
    e.preventDefault();
    const url = `/app/plataforma-tenants?q=${encodeURIComponent(termo.trim())}`;
    if (pathname === "/app/plataforma-tenants") window.location.assign(url);
    else navigate(url);
  };

  const sair = async () => {
    try { await doLogout(); } finally { navigate("/login"); }
  };

  return (
    <header className="mx-3 md:mx-5 mt-3 md:mt-5 px-3 py-2.5 rounded-2xl border border-border/60 bg-card flex items-center gap-3">
      <style>{`[data-testid="sidebar-footer-fale-conosco"]{display:none!important}`}</style>

      <button
        onClick={onOpenMobileMenu}
        className="md:hidden h-10 w-10 rounded-lg border border-border/70 inline-flex items-center justify-center"
        aria-label="Abrir menu"
      >
        <Menu className="h-4 w-4" />
      </button>

      <form onSubmit={buscar} className="relative flex-1 max-w-xl">
        <label htmlFor="owner-busca" className="sr-only">Buscar escritório</label>
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        <input
          id="owner-busca"
          value={termo}
          onChange={(e) => setTermo(e.target.value)}
          placeholder="Buscar escritório por nome, CNPJ ou e-mail…"
          className="w-full h-10 pl-9 pr-3 rounded-xl border border-border/70 bg-background text-sm focus:outline-none focus:border-primary/50"
        />
      </form>

      <div className="ml-auto flex items-center gap-2 shrink-0">
        <div className="h-10 pl-1.5 pr-3 rounded-xl border border-border/70 inline-flex items-center gap-2 text-sm">
          <span className="h-7 w-7 rounded-md bg-primary text-primary-foreground text-[11px] font-semibold inline-flex items-center justify-center">
            {(user?.name || "?").charAt(0).toUpperCase()}
          </span>
          <span className="hidden sm:flex flex-col leading-tight">
            <span className="font-medium">{(user?.name || "").split(" ")[0]}</span>
            <span className="text-[10.5px] text-muted-foreground">Platform owner</span>
          </span>
        </div>
        {typeof doLogout === "function" && (
          <button
            onClick={sair}
            title="Sair"
            aria-label="Sair"
            className="h-10 w-10 rounded-lg border border-border/70 hover:border-primary/40 inline-flex items-center justify-center"
          >
            <LogOut className="h-4 w-4" />
          </button>
        )}
      </div>
    </header>
  );
}
